// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddUserToModal_overlay__8i9sX {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000000cc;
  z-index: 1000;
}
.AddUserToModal_closeIcon__ucelV {
  width: 24px;
  height: 24;
  position: absolute;
  right: 3%;
  top: 5%;
  cursor: pointer;
  background-color: transparent;
  border: none;
}
.AddUserToModal_overlay__8i9sX,
.AddUserToModal_container__K-AIZ,
.AddUserToModal_acceptBtn__xhWxJ,
.AddUserToModal_cancelBtn__feMtL {
  display: flex;
  align-items: center;
  justify-content: center;
}
.AddUserToModal_container__K-AIZ {
  width: 40%;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 6px 32px 6px 32px;
}

.AddUserToModal_zakupiteljContainer__bF1lC {
  height: 424px;
}
.AddUserToModal_groupContainer__fW19D {
  height: 630px;
}
.AddUserToModal_wrapper__He40O {
  width: 80%;
  gap: 24px;
}
.AddUserToModal_wrapper__He40O {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-direction: column;
}
.AddUserToModal_title__tXR3X {
  font-size: 28px;
  line-height: 34px;
}
.AddUserToModal_title__tXR3X,
.AddUserToModal_subtitle__fsIot {
  color: #4d4d4d;
  font-weight: 600;
}
.AddUserToModal_subtitle__fsIot {
  font-size: 20px;
  font-style: normal;
  line-height: 22px;
  margin-top: 16px;
}
.AddUserToModal_label__LdMEN {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #5f6d7e;
}
.AddUserToModal_title__tXR3X,
.AddUserToModal_label__LdMEN,
.AddUserToModal_subtitle__fsIot {
  font-family: Inter;
  letter-spacing: -0.02px;
  text-align: left;
}
.AddUserToModal_btnRow__\\+mErC {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 16px;
  margin-top: 24px;
}

.AddUserToModal_cancelBtn__feMtL,
.AddUserToModal_acceptBtn__xhWxJ {
  font-family: Inter;
  font-weight: 600;
  text-align: left;
  height: 40px;
  padding: 30px 80px 30px 80px;
  border: none;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  border-radius: 4px;
  width: 100%;
  transition: backgroundColor 300ms ease-in-out;
  cursor: pointer;
}
.AddUserToModal_cancelBtn__feMtL:hover {
  background-color: #d8dbdf;
  color: #4e4e4e;
}
.AddUserToModal_acceptBtn__xhWxJ:hover {
  background-color: #8d6a19;
}
.AddUserToModal_acceptBtn__xhWxJ {
  background-color: #cb9c2d;
  color: #ffffff;
  width: 300px;
}
.AddUserToModal_cancelBtn__feMtL {
  color: #808080;
  background-color: #ebebeb;
  width: 148px;
}
.AddUserToModal_selectContainer__DdGyd {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/polazniciPregled/components/AddUserToModal/AddUserToModal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb","sourcesContent":[".overlay {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: #000000cc;\n  z-index: 1000;\n}\n.closeIcon {\n  width: 24px;\n  height: 24;\n  position: absolute;\n  right: 3%;\n  top: 5%;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n}\n.overlay,\n.container,\n.acceptBtn,\n.cancelBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.container {\n  width: 40%;\n  border-radius: 16px;\n  background-color: #ffffff;\n  padding: 6px 32px 6px 32px;\n}\n\n.zakupiteljContainer {\n  height: 424px;\n}\n.groupContainer {\n  height: 630px;\n}\n.wrapper {\n  width: 80%;\n  gap: 24px;\n}\n.wrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  flex-direction: column;\n}\n.title {\n  font-size: 28px;\n  line-height: 34px;\n}\n.title,\n.subtitle {\n  color: #4d4d4d;\n  font-weight: 600;\n}\n.subtitle {\n  font-size: 20px;\n  font-style: normal;\n  line-height: 22px;\n  margin-top: 16px;\n}\n.label {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #5f6d7e;\n}\n.title,\n.label,\n.subtitle {\n  font-family: Inter;\n  letter-spacing: -0.02px;\n  text-align: left;\n}\n.btnRow {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.cancelBtn,\n.acceptBtn {\n  font-family: Inter;\n  font-weight: 600;\n  text-align: left;\n  height: 40px;\n  padding: 30px 80px 30px 80px;\n  border: none;\n  text-align: center;\n  color: #ffffff;\n  font-size: 16px;\n  border-radius: 4px;\n  width: 100%;\n  transition: backgroundColor 300ms ease-in-out;\n  cursor: pointer;\n}\n.cancelBtn:hover {\n  background-color: #d8dbdf;\n  color: #4e4e4e;\n}\n.acceptBtn:hover {\n  background-color: #8d6a19;\n}\n.acceptBtn {\n  background-color: #cb9c2d;\n  color: #ffffff;\n  width: 300px;\n}\n.cancelBtn {\n  color: #808080;\n  background-color: #ebebeb;\n  width: 148px;\n}\n.selectContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AddUserToModal_overlay__8i9sX`,
	"closeIcon": `AddUserToModal_closeIcon__ucelV`,
	"container": `AddUserToModal_container__K-AIZ`,
	"acceptBtn": `AddUserToModal_acceptBtn__xhWxJ`,
	"cancelBtn": `AddUserToModal_cancelBtn__feMtL`,
	"zakupiteljContainer": `AddUserToModal_zakupiteljContainer__bF1lC`,
	"groupContainer": `AddUserToModal_groupContainer__fW19D`,
	"wrapper": `AddUserToModal_wrapper__He40O`,
	"title": `AddUserToModal_title__tXR3X`,
	"subtitle": `AddUserToModal_subtitle__fsIot`,
	"label": `AddUserToModal_label__LdMEN`,
	"btnRow": `AddUserToModal_btnRow__+mErC`,
	"selectContainer": `AddUserToModal_selectContainer__DdGyd`
};
export default ___CSS_LOADER_EXPORT___;
